"use strict";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Address from "../../components/address";
import Api from "../../api/api";
import DebtorTypeAhead from "../debtor_typeahead";
import FactorBrokersService from "../factor_brokers_service";
import FactorInvoicesService from "../factor_invoices_service";
import FactorInvoicesStore from "../../stores/factor_invoices_store";
import generalFormatter from "../../formatters/general";
import WaitingSpinner from "../../components/waiting_spinner";
import DocumentTitle from "react-document-title";
import ReactUtils from "../../react_utils";
import { storeChangedEvent } from "../../stores/object_with_id_store";
const bem = ReactUtils.makeBem("debtor-setter");
function initialStateForGroup() {
  return {
    factorBroker: null,
    factorInvoice: {},
    loadingInvoice: true,
    savingInvoice: false,
    noDebtorSelected: null
  };
}
function possibleDebtorPhoneNumber(priOrSec, phoneNumber) {
  if (!_.isEmpty(phoneNumber)) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { tabIndex: -1, href: "tel:" + phoneNumber }, priOrSec, ": ", phoneNumber.replaceAll(" ", "-"), " "));
  }
}
function getDebtorEmail(debtor) {
  var _a, _b;
  return (_b = (_a = debtor.cadence_debtor_details.email) != null ? _a : debtor.billing_contact.email) != null ? _b : null;
}
function possibleDebtorEmail(debtor) {
  const possibleEmail = getDebtorEmail(debtor);
  if (possibleEmail != null) return /* @__PURE__ */ React.createElement("div", null, "Email: ", possibleEmail);
  return null;
}
function possibleDebtorNoBuy(debtor) {
  if (debtor.no_buy) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert" }), "\xA0No Buy");
  }
}
function needsDebtor(groupState) {
  return !groupState.factorBroker;
}
var DebtorSetter = React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  getInitialState: function() {
    return {
      groups: {}
    };
  },
  componentWillMount: function() {
    $(FactorInvoicesStore).on(
      storeChangedEvent("FactorInvoices"),
      this.invoiceStoreUpdated
    );
    this.loadDataForCurrentGroup(this.props);
  },
  componentWillUnmount: function() {
    $(FactorInvoicesStore).off(
      storeChangedEvent("FactorInvoices"),
      this.invoiceStoreUpdated
    );
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.groupID != newProps.groupID) {
      this.loadDataForCurrentGroup(newProps);
    }
  },
  stateForGroup: function(props) {
    return this.state.groups[this.currentGroupID(props)] || initialStateForGroup();
  },
  setStateForGroup: function(values, props, callback) {
    if (this.isMounted()) {
      var newState = this.state;
      var currentState = newState.groups[this.currentGroupID(props)] || initialStateForGroup();
      newState.groups[this.currentGroupID(props)] = currentState;
      _.extend(currentState, values);
      this.setState(newState, callback);
    }
  },
  currentGroupID: function(props) {
    if ((props || this.props).groupID) {
      return (props || this.props).groupID;
    }
    return "nogroup";
  },
  updateFromRemote: function(data, props) {
    this.stateForGroup(props);
    var newState = {
      factorInvoice: data.factor_invoice,
      factorBroker: data.factor_broker,
      loadingInvoice: false,
      savingInvoice: false,
      noDebtorSelected: data.factor_invoice.data["no_debtor_selected"]
    };
    this.setStateForGroup(newState, props || this.state.props);
  },
  loadDataForCurrentGroup: function(props) {
    const invoiceId = props.factorInvoiceId;
    FactorInvoicesService.fetchInvoiceAndRelated(invoiceId).then(
      ({ factorInvoice }) => {
        this.fetchDebtorAndUpdate(
          factorInvoice.factor_broker_id,
          factorInvoice,
          props
        );
      },
      _.identity
    );
  },
  fetchDebtorAndUpdate: function(factorBrokerId, factorInvoice, props) {
    FactorBrokersService.getWithId(factorBrokerId).then((factorBroker) => {
      this.updateFromRemote(
        {
          factor_invoice: factorInvoice,
          factor_broker: factorBroker
        },
        props
      );
    }, _.identity);
  },
  invoiceStoreUpdated: function() {
    if (this.isMounted() && this.factorInvoice() && this.factorInvoice().id) {
      const updatedInvoice = FactorInvoicesStore.find(this.factorInvoice().id);
      if (updatedInvoice.updated_at != this.factorInvoice().updated_at) {
        var fakeData = {
          factor_invoice: updatedInvoice,
          factor_broker: this.stateForGroup().factorBroker
        };
        this.updateFromRemote(fakeData, this.props);
      }
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { "data-component": "DebtorSetter", title: "TriumphPay Audit \u2013 Assign Debtor" }, /* @__PURE__ */ React.createElement("div", { className: bem("") }, /* @__PURE__ */ React.createElement("h3", null, `Assign Debtor for Group ${this.props.groupNumber}`), /* @__PURE__ */ React.createElement("hr", null), this.assignDebtorForm()));
  },
  assignDebtorForm: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.stateForGroup().loadingInvoice }, this.factorInvoice() ? /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement("form", { onSubmit: this.handleContinue }, this.loadInformationFields(), /* @__PURE__ */ React.createElement("div", { className: bem("__actions") }, /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: this.handleNoDebtorButtonClicked,
        className: "debtor-setter__no_debtor_available"
      },
      "No debtor available"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        disabled: this.currentGroupNeedsDebtor() || this.stateForGroup().savingInvoice || this.stateForGroup().loadingInvoice,
        className: "debtor-setter__submit"
      },
      "Continue"
    )))) : /* @__PURE__ */ React.createElement("div", null));
  },
  invoiceDate: function() {
    if (this.stateForGroup()["factorInvoice"]["source_invoice_date"]) {
      return generalFormatter.superShortDate(
        this.stateForGroup()["factorInvoice"]["source_invoice_date"]
      );
    } else {
      return "Not found";
    }
  },
  loadInformationFields: function() {
    var carrier = this.carrier();
    var silo = carrier && carrier.silo;
    return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label") }, /* @__PURE__ */ React.createElement("label", null, "Debtor")), /* @__PURE__ */ React.createElement(
      DebtorTypeAhead,
      {
        onSelectDebtor: this.debtorSelected,
        autoFocus: true,
        readOnly: false,
        onClearDebtor: this.debtorCleared,
        silo,
        factorBroker: this.stateForGroup().factorBroker
      }
    ), /* @__PURE__ */ React.createElement("br", null)), this.debtor() ? /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Debtor Details"), this.debtorDetails()) : null), this.possibleDebtorWarning(), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Load ID:"), this.groupValue(this.stateForGroup()["factorInvoice"]["load_id"])), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Invoice Number:"), this.groupValue(
      this.stateForGroup()["factorInvoice"]["source_invoice_number"]
    )), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Date:"), this.groupValue(this.invoiceDate()))));
  },
  groupValue: function(value) {
    if (!this.stateForGroup().loadingInvoice) {
      return /* @__PURE__ */ React.createElement("span", { className: "group-value" }, value || "Not found");
    }
  },
  loadInformationActions: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__actions") }, /* @__PURE__ */ React.createElement(
      "button",
      {
        disabled: this.stateForGroup().savingInvoice,
        className: "debtor-setter__no_debtor_available"
      },
      "No debtor available"
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        disabled: this.currentGroupNeedsDebtor() || this.stateForGroup().savingInvoice,
        className: "debtor-setter__submit"
      },
      "Continue"
    ));
  },
  saveInvoice: function(callback = null) {
    if (!this.factorInvoice()) return;
    var props = this.props;
    const params = {
      factor_invoice: this.factorInvoiceParams()
    };
    this.setStateForGroup({ savingInvoice: true });
    return Api.FactorInvoices.create(params).then((data) => {
      this.updateFromRemote(data, props);
      if (callback) {
        callback();
      }
    }).catch((e) => {
      const updatedState = _.tap({ savingInvoice: false }, (state) => {
        const errorFields = _.chain(
          e.responseJSON && e.responseJSON.errors || []
        ).pluck("field").compact().value();
        if (errorFields.includes("source_invoice_amount")) {
          state.source_invoice_amount = null;
        }
      });
      this.setStateForGroup(updatedState, props, this.forceUpdate);
    });
  },
  factorInvoiceParams: function() {
    return {
      id: this.factorInvoice() ? this.factorInvoice().id : null,
      factor_broker_id: this.stateForGroup().factorBroker ? this.stateForGroup().factorBroker.id : null,
      no_debtor_selected: this.stateForGroup().noDebtorSelected
    };
  },
  carrierId: function() {
    var carrier = this.carrier();
    return carrier && carrier.id;
  },
  carrier: function() {
    return this.state.carrier;
  },
  factorInvoice: function() {
    return this.stateForGroup().factorInvoice;
  },
  debtor() {
    return this.stateForGroup().factorBroker;
  },
  debtorSelected: function(factorBroker) {
    this.setStateForGroup(
      { factorBroker, noDebtorSelected: false },
      null,
      () => {
        this.saveInvoice();
      }
    );
  },
  debtorCleared: function() {
    if (this.stateForGroup().loadingInvoice || this.stateForGroup().savingInvoice) {
      return;
    }
    this.setStateForGroup({ factorBroker: null }, null, () => {
      this.saveInvoice();
    });
  },
  debtorDetails: function() {
    const debtor = this.debtor();
    if (debtor) {
      return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__compact-address" }, /* @__PURE__ */ React.createElement(Address, { source: debtor.payment_address, compact: true }), possibleDebtorEmail(debtor), possibleDebtorNoBuy(debtor), possibleDebtorPhoneNumber("Primary", debtor.external_data.Phone1), possibleDebtorPhoneNumber("Secondary", debtor.external_data.Phone2));
    }
  },
  possibleDebtorWarning: function() {
    const debtor = this.stateForGroup().factorBroker;
    if (debtor && !_.isEmpty(debtor.warning)) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__debtor-warning" }, /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert" }), /* @__PURE__ */ React.createElement("div", { className: "debtor-name" }, debtor.name), /* @__PURE__ */ React.createElement("div", { className: "debtor-warning" }, debtor.warning))));
    }
  },
  handleContinue(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.props.reloadDocumentBatch().then(() => {
      this.props.didCompleteGroup();
    });
  },
  handleNoDebtorButtonClicked(event) {
    event.stopPropagation();
    event.preventDefault();
    this.setStateForGroup(
      { factorBroker: null, noDebtorSelected: true },
      null,
      () => {
        this.saveInvoice(this.handleContinue);
      }
    );
  },
  currentGroupNeedsDebtor: function() {
    return needsDebtor(this.stateForGroup());
  }
});
export default DebtorSetter;
